<template>
  <div class="image-album">
    <form-file :name="`img_${index}`" use-case="cover"/>
    <form-input :name="`img_desc_${index}`"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/create-form/Input'
  import FormFile from '@/components/create-form/File'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage');

  export default {
    name: "ImageAlbum",
    props: ['index'],
    data() {
      return {}
    },
    computed: {
      ...mapState([
        'isError',
        'fields'
      ])
    },
    methods: {
      ...mapMutations([
        'setIsError',
        'setFileExtension',
        'setInitFields',
        'deleteField'
      ]),
      ...mapActions([
        'initField'
      ])
    },
    created() {
      this.setFileExtension({name: `img_${this.index}`, value: ['jpg', 'jpeg', 'png', 'gif']})
      let savedData = {};
      if (localStorage.hasOwnProperty(this.$route.path)) {
        savedData = JSON.parse(localStorage.getItem(this.$route.path))
      }
      this.initField({index: this.index, name: 'img_desc_', value: {
          value: savedData.hasOwnProperty(`img_desc_${this.index}`)? savedData[`img_desc_${this.index}`] : '',
          parameterName: 'img_desc',
          name: 'Подпись изображения',
          errorId: null,
          type: 'slider-img-desc',
          errors: {empty: 'Введите подпись изображение'},
          tabId: 0,
        }
      })
      this.initField({index: this.index, name: 'img_', value: {
          value: savedData.hasOwnProperty(`img_${this.index}`)? savedData[`img_${this.index}`] : '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          type: 'slider-img',
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0,
        }
      })
    },
    beforeDestroy() {
      this.deleteField(`img_${this.index}`);
      this.deleteField(`img_desc_${this.index}`);
    },
    components: {
      FormFile,
      FormInput
    }
  }
</script>

<style scoped>
  .block {
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #e4e8eb;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/create-form/ImageAlbum.vue